export enum RouteRegEx {
  User = '(view|edit|add|copy)user',
  Organisation = '(view|edit|add)organisation',
  Role = '(view|edit|add|copy)role',
  WorkflowQueue = 'workflowjob',
  ScriveEditTemplateAfterSignMappings = 'scriveedittemplateaftersignmappings',
  DocuSignAdditionalDocuments = 'docusignaddadditionaldocument|docusigneditadditionaldocument',
  DocuSignAdditionalDocumentTabs = 'docusigneditadditionaldocumentsigntab|docusignaddadditionaldocumentsigntab',
  DocuSignSignerRoles = 'docusigneditsignerrole|docusignaddsignerrole',
  DocuSignEditTemplateAfterSignMappings = 'docusignedittemplateaftersignmappings',
  DocuSignTemplates = 'docusignedittemplate|docusignaddtemplate|docusigneditdocumenttypes',
  DocuSignTemplateSignHeres = 'docusignedittemplatesignhere|docusignaddtemplatesignhere',
  DocuSignTemplateAdditionalDocuments = 'docusignedittemplateadditionaldocument|docusignaddtemplateadditionaldocument',
  LockMaintenance = 'lockmaintenancetablestorekeylocks|lockmaintenancetablestorekeylocks',
  ScriveSignerRoles = 'scriveeditsignerrole|scriveaddsignerrole',
  ScriveTemplates = 'scriveedittemplate|scriveaddtemplate|scriveeditsigningpartyfield|scriveeditdocumenttypes',
  ScriveSigningParties = 'scriveeditsigningparty|scriveaddsigningparty',
  ScriveSigningPartyFields = 'scriveeditsigningpartyfield|scriveaddsigningpartyfield',
  ScriveSigningPartyFieldPlacements = 'scriveeditsigningpartyfieldplacement|scriveaddsigningpartyfieldplacement'
}
